import React, { PureComponent } from 'react';
import { Rgba } from '../../../../helpers/helpers';
import { determineBackgroundColor, determineFillOpacity } from '../../../helpers';
import { SendAFormInteractive, withSendAFormInteractiveState } from '../../SendAFormInteractiveState';

export type FieldWrapperProps = {
  id?: string;
  fieldId?: string;
  children?: React.ReactNode;
  onMouseDown?: VoidFunc;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  backgroundColor?: Rgba;
  editable?: boolean;
} & SendAFormInteractive;

class FieldWrapper extends PureComponent<FieldWrapperProps, TypeMePlease> {
  private svg: ExplicitAny;
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
  }

  componentDidMount() {
    if (this.svg.ontouchstart) {
      this.svg.addEventListener('touchstart', this.mouseDown);
    } else {
      this.svg.addEventListener('mousedown', this.mouseDown);
    }
  }

  componentWillUnmount() {
    this.svg.removeEventListener('touchstart', this.mouseDown);
    this.svg.removeEventListener('mousedown', this.mouseDown);
  }

  mouseDown() {
    if (!this.props.interactive) {
      // we're clicking a field from the send a form v2 preview, so we want to raise
      // the field click event for send a form v2
      this.props.onSendAFormFieldClick(this.props.fieldId, 'form');
      return;
    }

    if (!this.props.editable) {
      return;
    }
    if (this.props.onMouseDown) {
      this.props.onMouseDown();
    }
  }

  render() {
    // before intrducing send a form v2's ability to preview the form with field color highlighting,
    // non-editable fields are transparent and not clickable
    // with send a form v2, we need to show the field colors, but not let them be interacted with (interactive)
    const { backgroundColor, editable, interactive, sendAFormSelected } = this.props;
    const fill = determineBackgroundColor(editable, interactive, backgroundColor);
    const fillOpacity = determineFillOpacity(editable, interactive, backgroundColor);
    // explicitly look for false since a deselected field will have been explicitly set to false
    const outline = !sendAFormSelected ? { stroke: '#000', strokeWidth: 3, strokeDasharray: '6,4' } : {};

    return (
      <svg
        ref={(r) => {
          this.svg = r;
        }}
        x={this.props.x}
        y={this.props.y}
        width={this.props.w}
        height={this.props.h}
        id={this.props.id}
        data-fieldid={this.props.fieldId}
        data-testid="field-wrapper"
      >
        <g>
          {/* only apply the outline if we're in send a form preview (interactive === false) */}
          <rect width="100%" height="100%" fill={fill} fillOpacity={fillOpacity} {...(interactive ? {} : outline)} />
          {this.props.children}
        </g>
      </svg>
    );
  }
}

export default withSendAFormInteractiveState(FieldWrapper);
